import Megaphone from '@/assets/icons/megaphone.png';
import { HSpacer, Text, VSpacer } from '@/components/DesignSystem';
import { ApiFarmerRewards } from '@api/interfaces/ApiFarmerRewards';
import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import { Stack } from '@mui/material';
import { daysFromDate, getJsDateFromString } from '@shared/utilities';
import React from 'react';

interface ReEarnStatusBannerProps {
  farmerRewards: ApiFarmerRewards,
  program: ApiRewardsProgram,
}

export const ReEarnStatusBanner = ({
  farmerRewards,
  program,
}: ReEarnStatusBannerProps) => {
  const programEndJsDate = getJsDateFromString(program.endDate, { endOfDay: true });
  const daysUntilProgramEnd = Math.floor(-daysFromDate(programEndJsDate));

  const shouldShowReEarnTierBanner = (
    daysUntilProgramEnd <= 90
    && farmerRewards.rankCurrent !== null
    && (
      farmerRewards.rankEarned === null ||
      farmerRewards.rankEarned < farmerRewards.rankCurrent
    )
  );
  
  if (!shouldShowReEarnTierBanner) {
    return null;
  }

  return (
    <>
      <VSpacer size="4" />
      <Stack
        bgcolor="#F9F0FF"
        border="border: 1px solid rgba(0, 0, 0, 0.03)"
        borderRadius="8px"
        flexDirection="row"
        padding="14px 12px 16px 8px"
      >
        <img height={27} src={Megaphone} width={27} />
        <HSpacer size="3" />
        <Stack>
          <Text category="overline" fontWeight={700}>
            Don’t lose Your status!
          </Text>
          <Text category="body-small">
            Place your orders before the program period ends to be sure you
            re-earn your status.
          </Text>
        </Stack>
      </Stack>
    </>
  );
};
